import { ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { PHASE_META, PHASE_ORDER } from "./flowData";

/**
 * Top "at a glance" diagram for investors: the three phases
 * (Digital Mapping → Physical Mapping → Export) as large cards connected
 * by arrows. Horizontal on desktop, stacked on mobile.
 */
export function HeroJourney() {
  return (
    <div className="flex flex-col md:flex-row md:items-stretch gap-3 md:gap-2">
      {PHASE_ORDER.map((phase, i) => {
        const meta = PHASE_META[phase];
        const Icon = meta.icon;
        const stepCount = meta.stepNumbers.length;
        return (
          <div
            key={phase}
            className="flex flex-col md:flex-row md:items-center gap-3 md:gap-2 md:flex-1"
          >
            <Card
              className={`border-l-4 ${meta.color.border} flex-1 py-5 gap-3 transition-shadow hover:shadow-md`}
            >
              <div className="flex flex-col gap-3 px-5">
                <div
                  className={`flex items-center justify-center size-12 rounded-xl ${meta.color.bg}`}
                >
                  <Icon className={`size-6 ${meta.color.text}`} />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <span className={`text-xs font-semibold uppercase tracking-wide ${meta.color.text}`}>
                      Phase {i + 1}
                    </span>
                  </div>
                  <h3 className="text-base font-semibold text-foreground mt-0.5">
                    {meta.label}
                  </h3>
                  <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                    {meta.tagline}
                  </p>
                </div>
                <span className="text-xs font-medium text-muted-foreground">
                  {stepCount} {stepCount === 1 ? "step" : "steps"}
                </span>
              </div>
            </Card>

            {/* Connector arrow — points down on mobile, right on desktop */}
            {i < PHASE_ORDER.length - 1 && (
              <div className="flex items-center justify-center shrink-0">
                <ArrowRight className="size-5 text-muted-foreground rotate-90 md:rotate-0" />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
